export const calculateScl90Results = (responses) => {
  // Convertir las respuestas a números. Si están vacíos o no definidos, se consideran como 0.
  const scl90Preg001 = Number(responses.scl90Preg001) || 0;
  const scl90Preg002 = Number(responses.scl90Preg002) || 0;
  const scl90Preg003 = Number(responses.scl90Preg003) || 0;
  const scl90Preg004 = Number(responses.scl90Preg004) || 0;
  const scl90Preg005 = Number(responses.scl90Preg005) || 0;
  const scl90Preg006 = Number(responses.scl90Preg006) || 0;
  const scl90Preg007 = Number(responses.scl90Preg007) || 0;
  const scl90Preg008 = Number(responses.scl90Preg008) || 0;
  const scl90Preg009 = Number(responses.scl90Preg009) || 0;
  const scl90Preg010 = Number(responses.scl90Preg010) || 0;
  const scl90Preg011 = Number(responses.scl90Preg011) || 0;
  const scl90Preg012 = Number(responses.scl90Preg012) || 0;
  const scl90Preg013 = Number(responses.scl90Preg013) || 0;
  const scl90Preg014 = Number(responses.scl90Preg014) || 0;
  const scl90Preg015 = Number(responses.scl90Preg015) || 0;
  const scl90Preg016 = Number(responses.scl90Preg016) || 0;
  const scl90Preg017 = Number(responses.scl90Preg017) || 0;
  const scl90Preg018 = Number(responses.scl90Preg018) || 0;
  const scl90Preg019 = Number(responses.scl90Preg019) || 0;
  const scl90Preg020 = Number(responses.scl90Preg020) || 0;
  const scl90Preg021 = Number(responses.scl90Preg021) || 0;
  const scl90Preg022 = Number(responses.scl90Preg022) || 0;
  const scl90Preg023 = Number(responses.scl90Preg023) || 0;
  const scl90Preg024 = Number(responses.scl90Preg024) || 0;
  const scl90Preg025 = Number(responses.scl90Preg025) || 0;
  const scl90Preg026 = Number(responses.scl90Preg026) || 0;
  const scl90Preg027 = Number(responses.scl90Preg027) || 0;
  const scl90Preg028 = Number(responses.scl90Preg028) || 0;
  const scl90Preg029 = Number(responses.scl90Preg029) || 0;
  const scl90Preg030 = Number(responses.scl90Preg030) || 0;
  const scl90Preg031 = Number(responses.scl90Preg031) || 0;
  const scl90Preg032 = Number(responses.scl90Preg032) || 0;
  const scl90Preg033 = Number(responses.scl90Preg033) || 0;
  const scl90Preg034 = Number(responses.scl90Preg034) || 0;
  const scl90Preg035 = Number(responses.scl90Preg035) || 0;
  const scl90Preg036 = Number(responses.scl90Preg036) || 0;
  const scl90Preg037 = Number(responses.scl90Preg037) || 0;
  const scl90Preg038 = Number(responses.scl90Preg038) || 0;
  const scl90Preg039 = Number(responses.scl90Preg039) || 0;
  const scl90Preg040 = Number(responses.scl90Preg040) || 0;
  const scl90Preg041 = Number(responses.scl90Preg041) || 0;
  const scl90Preg042 = Number(responses.scl90Preg042) || 0;
  const scl90Preg043 = Number(responses.scl90Preg043) || 0;
  const scl90Preg044 = Number(responses.scl90Preg044) || 0;
  const scl90Preg045 = Number(responses.scl90Preg045) || 0;
  const scl90Preg046 = Number(responses.scl90Preg046) || 0;
  const scl90Preg047 = Number(responses.scl90Preg047) || 0;
  const scl90Preg048 = Number(responses.scl90Preg048) || 0;
  const scl90Preg049 = Number(responses.scl90Preg049) || 0;
  const scl90Preg050 = Number(responses.scl90Preg050) || 0;
  const scl90Preg051 = Number(responses.scl90Preg051) || 0;
  const scl90Preg052 = Number(responses.scl90Preg052) || 0;
  const scl90Preg053 = Number(responses.scl90Preg053) || 0;
  const scl90Preg054 = Number(responses.scl90Preg054) || 0;
  const scl90Preg055 = Number(responses.scl90Preg055) || 0;
  const scl90Preg056 = Number(responses.scl90Preg056) || 0;
  const scl90Preg057 = Number(responses.scl90Preg057) || 0;
  const scl90Preg058 = Number(responses.scl90Preg058) || 0;
  const scl90Preg059 = Number(responses.scl90Preg059) || 0;
  const scl90Preg060 = Number(responses.scl90Preg060) || 0;
  const scl90Preg061 = Number(responses.scl90Preg061) || 0;
  const scl90Preg062 = Number(responses.scl90Preg062) || 0;
  const scl90Preg063 = Number(responses.scl90Preg063) || 0;
  const scl90Preg064 = Number(responses.scl90Preg064) || 0;
  const scl90Preg065 = Number(responses.scl90Preg065) || 0;
  const scl90Preg066 = Number(responses.scl90Preg066) || 0;
  const scl90Preg067 = Number(responses.scl90Preg067) || 0;
  const scl90Preg068 = Number(responses.scl90Preg068) || 0;
  const scl90Preg069 = Number(responses.scl90Preg069) || 0;
  const scl90Preg070 = Number(responses.scl90Preg070) || 0;
  const scl90Preg071 = Number(responses.scl90Preg071) || 0;
  const scl90Preg072 = Number(responses.scl90Preg072) || 0;
  const scl90Preg073 = Number(responses.scl90Preg073) || 0;
  const scl90Preg074 = Number(responses.scl90Preg074) || 0;
  const scl90Preg075 = Number(responses.scl90Preg075) || 0;
  const scl90Preg076 = Number(responses.scl90Preg076) || 0;
  const scl90Preg077 = Number(responses.scl90Preg077) || 0;
  const scl90Preg078 = Number(responses.scl90Preg078) || 0;
  const scl90Preg079 = Number(responses.scl90Preg079) || 0;
  const scl90Preg080 = Number(responses.scl90Preg080) || 0;
  const scl90Preg081 = Number(responses.scl90Preg081) || 0;
  const scl90Preg082 = Number(responses.scl90Preg082) || 0;
  const scl90Preg083 = Number(responses.scl90Preg083) || 0;
  const scl90Preg084 = Number(responses.scl90Preg084) || 0;
  const scl90Preg085 = Number(responses.scl90Preg085) || 0;
  const scl90Preg086 = Number(responses.scl90Preg086) || 0;
  const scl90Preg087 = Number(responses.scl90Preg087) || 0;
  const scl90Preg088 = Number(responses.scl90Preg088) || 0;
  const scl90Preg089 = Number(responses.scl90Preg089) || 0;
  const scl90Preg090 = Number(responses.scl90Preg090) || 0;

  // Calcular la suma total de las respuestas
  const totalSumSom =
    scl90Preg001 +
    scl90Preg004 +
    scl90Preg012 +
    scl90Preg027 +
    scl90Preg040 +
    scl90Preg042 +
    scl90Preg048 +
    scl90Preg049 +
    scl90Preg052 +
    scl90Preg053 +
    scl90Preg056 +
    scl90Preg058;
  

    // Contador respuestas seleccionadas SOM

  const countSelectedResponsesSom = () => {
    let count = 0;

    if (scl90Preg001 !== "") {
      count++;
    }
    if (scl90Preg004 !== "") {
      count++;
    }
    if (scl90Preg012 !== "") {
      count++;
    }
    if (scl90Preg027 !== "") {
      count++;
    }
    if (scl90Preg040 !== "") {
      count++;
    }
    if (scl90Preg042 !== "") {
      count++;
    }
    if (scl90Preg048 !== "") {
      count++;
    }
    if (scl90Preg049 !== "") {
      count++;
    }
    if (scl90Preg052 !== "") {
      count++;
    }
    if (scl90Preg053 !== "") {
      count++;
    }
    if (scl90Preg056 !== "") {
      count++;
    }
    if (scl90Preg058 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores SOM y respuestas seleccionadas SOM

  const totalDimenSom = (
    totalSumSom / countSelectedResponsesSom() || 0
  ).toFixed(2);

  // Calculo baremo percentil SOM

  const percSomHomb =
    totalDimenSom < 0.08
      ? 5
      : totalDimenSom >= 0.08 && totalDimenSom < 0.17
      ? 20
      : totalDimenSom >= 0.17 && totalDimenSom < 0.25
      ? 35
      : totalDimenSom >= 0.25 && totalDimenSom < 0.33
      ? 45
      : totalDimenSom >= 0.33 && totalDimenSom < 0.42
      ? 60
      : totalDimenSom >= 0.42 && totalDimenSom < 0.5
      ? 65
      : totalDimenSom >= 0.5 && totalDimenSom < 0.58
      ? 70
      : totalDimenSom >= 0.58 && totalDimenSom < 0.62
      ? 75
      : totalDimenSom >= 0.62 && totalDimenSom < 0.67
      ? 80
      : totalDimenSom >= 0.67 && totalDimenSom < 0.92
      ? 85
      : totalDimenSom >= 0.92 && totalDimenSom < 1.33
      ? 90
      : totalDimenSom >= 1.33 && totalDimenSom < 1.53
      ? 95
      : totalDimenSom >= 1.53 && totalDimenSom < 2.08
      ? 97
      : totalDimenSom >= 2.08
      ? 99
      : "";

  const percSomMuj =
    totalDimenSom < 0.08
      ? 5
      : totalDimenSom >= 0.08 && totalDimenSom < 0.17
      ? 15
      : totalDimenSom >= 0.17 && totalDimenSom < 0.25
      ? 20
      : totalDimenSom >= 0.25 && totalDimenSom < 0.33
      ? 25
      : totalDimenSom >= 0.33 && totalDimenSom < 0.42
      ? 35
      : totalDimenSom >= 0.42 && totalDimenSom < 0.5
      ? 40
      : totalDimenSom >= 0.5 && totalDimenSom < 0.58
      ? 45
      : totalDimenSom >= 0.58 && totalDimenSom < 0.67
      ? 50
      : totalDimenSom >= 0.67 && totalDimenSom < 0.75
      ? 55
      : totalDimenSom >= 0.75 && totalDimenSom < 0.83
      ? 60
      : totalDimenSom >= 0.83 && totalDimenSom < 0.92
      ? 65
      : totalDimenSom >= 0.92 && totalDimenSom < 1.08
      ? 70
      : totalDimenSom >= 1.08 && totalDimenSom < 1.17
      ? 75
      : totalDimenSom >= 1.17 && totalDimenSom < 1.42
      ? 80
      : totalDimenSom >= 1.42 && totalDimenSom < 1.5
      ? 85
      : totalDimenSom >= 1.5 && totalDimenSom < 1.92
      ? 90
      : totalDimenSom >= 1.92 && totalDimenSom < 2.19
      ? 95
      : totalDimenSom >= 2.19 && totalDimenSom < 2.72
      ? 97
      : totalDimenSom >= 2.72
      ? 99
      : "";

  // Sumatorio de valores de respuestas OBS

  const totalSumObs =
    (parseInt(scl90Preg003) || 0) +
    (parseInt(scl90Preg009) || 0) +
    (parseInt(scl90Preg010) || 0) +
    (parseInt(scl90Preg028) || 0) +
    (parseInt(scl90Preg038) || 0) +
    (parseInt(scl90Preg045) || 0) +
    (parseInt(scl90Preg046) || 0) +
    (parseInt(scl90Preg051) || 0) +
    (parseInt(scl90Preg055) || 0) +
    (parseInt(scl90Preg065) || 0);

  // Contador respuestas seleccionadas OBS

  const countSelectedResponsesObs = () => {
    let count = 0;

    if (scl90Preg003 !== "") {
      count++;
    }
    if (scl90Preg009 !== "") {
      count++;
    }
    if (scl90Preg010 !== "") {
      count++;
    }
    if (scl90Preg028 !== "") {
      count++;
    }
    if (scl90Preg038 !== "") {
      count++;
    }
    if (scl90Preg045 !== "") {
      count++;
    }
    if (scl90Preg046 !== "") {
      count++;
    }
    if (scl90Preg051 !== "") {
      count++;
    }
    if (scl90Preg055 !== "") {
      count++;
    }
    if (scl90Preg065 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores OBS y respuestas seleccionadas OBS

  const totalDimenObs = (
    totalSumObs / countSelectedResponsesObs() || 0
  ).toFixed(2);

  // Calculo baremo percentil OBS

  const percObsHomb =
    totalDimenObs < 0.1
      ? 5
      : totalDimenObs >= 0.1 && totalDimenObs < 0.2
      ? 10
      : totalDimenObs >= 0.2 && totalDimenObs < 0.3
      ? 15
      : totalDimenObs >= 0.3 && totalDimenObs < 0.4
      ? 30
      : totalDimenObs >= 0.4 && totalDimenObs < 0.5
      ? 40
      : totalDimenObs >= 0.5 && totalDimenObs < 0.6
      ? 50
      : totalDimenObs >= 0.6 && totalDimenObs < 0.7
      ? 55
      : totalDimenObs >= 0.7 && totalDimenObs < 0.8
      ? 65
      : totalDimenObs >= 0.8 && totalDimenObs < 0.9
      ? 75
      : totalDimenObs >= 0.9 && totalDimenObs < 1.0
      ? 80
      : totalDimenObs >= 1.0 && totalDimenObs < 1.1
      ? 85
      : totalDimenObs >= 1.1 && totalDimenObs < 1.4
      ? 90
      : totalDimenObs >= 1.4 && totalDimenObs < 1.5
      ? 95
      : totalDimenObs >= 1.5 && totalDimenObs < 2.4
      ? 97
      : totalDimenObs >= 2.4
      ? 99
      : "";


  const percObsMuj =
    totalDimenObs < 0.1
      ? 5
      : totalDimenObs >= 0.1 && totalDimenObs < 0.2
      ? 15
      : totalDimenObs >= 0.2 && totalDimenObs < 0.3
      ? 20
      : totalDimenObs >= 0.3 && totalDimenObs < 0.4
      ? 30
      : totalDimenObs >= 0.4 && totalDimenObs < 0.46
      ? 40
      : totalDimenObs >= 0.46 && totalDimenObs < 0.5
      ? 45
      : totalDimenObs >= 0.5 && totalDimenObs < 0.6
      ? 50
      : totalDimenObs >= 0.6 && totalDimenObs < 0.7
      ? 55
      : totalDimenObs >= 0.7 && totalDimenObs < 0.8
      ? 65
      : totalDimenObs >= 0.8 && totalDimenObs < 0.9
      ? 70
      : totalDimenObs >= 0.9 && totalDimenObs < 1.0
      ? 75
      : totalDimenObs >= 1.0 && totalDimenObs < 1.2
      ? 80
      : totalDimenObs >= 1.2 && totalDimenObs < 1.4
      ? 85
      : totalDimenObs >= 1.4 && totalDimenObs < 1.91
      ? 90
      : totalDimenObs >= 1.91 && totalDimenObs < 2.1
      ? 95
      : totalDimenObs >= 2.1 && totalDimenObs < 2.42
      ? 97
      : totalDimenObs >= 2.42
      ? 99
      : "";


  // Sumatorio de valores de respuestas SI

  const totalSumSi =
    (parseInt(scl90Preg006) || 0) +
    (parseInt(scl90Preg021) || 0) +
    (parseInt(scl90Preg034) || 0) +
    (parseInt(scl90Preg036) || 0) +
    (parseInt(scl90Preg037) || 0) +
    (parseInt(scl90Preg041) || 0) +
    (parseInt(scl90Preg061) || 0) +
    (parseInt(scl90Preg069) || 0) +
    (parseInt(scl90Preg073) || 0);

  // Contador respuestas seleccionadas SI

  const countSelectedResponsesSi = () => {
    let count = 0;

    if (scl90Preg006 !== "") {
      count++;
    }
    if (scl90Preg021 !== "") {
      count++;
    }
    if (scl90Preg034 !== "") {
      count++;
    }
    if (scl90Preg036 !== "") {
      count++;
    }
    if (scl90Preg037 !== "") {
      count++;
    }
    if (scl90Preg041 !== "") {
      count++;
    }
    if (scl90Preg061 !== "") {
      count++;
    }
    if (scl90Preg069 !== "") {
      count++;
    }
    if (scl90Preg073 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores SI y respuestas seleccionadas SI

  const totalDimenSi = (totalSumSi / countSelectedResponsesSi() || 0).toFixed(
    2
  );

  // Calculo baremo percentil SI

  const percSiHomb =
    totalDimenSi < 0.11
      ? 5
      : totalDimenSi >= 0.11 && totalDimenSi < 0.22
      ? 20
      : totalDimenSi >= 0.22 && totalDimenSi < 0.33
      ? 35
      : totalDimenSi >= 0.33 && totalDimenSi < 0.44
      ? 45
      : totalDimenSi >= 0.44 && totalDimenSi < 0.56
      ? 55
      : totalDimenSi >= 0.56 && totalDimenSi < 0.67
      ? 65
      : totalDimenSi >= 0.67 && totalDimenSi < 0.78
      ? 75
      : totalDimenSi >= 0.78 && totalDimenSi < 0.89
      ? 80
      : totalDimenSi >= 0.89 && totalDimenSi < 1.22
      ? 90
      : totalDimenSi >= 1.22 && totalDimenSi < 1.44
      ? 95
      : totalDimenSi >= 1.44 && totalDimenSi < 1.61
      ? 97
      : totalDimenSi >= 1.61
      ? 99
      : "";

  const percSiMuj =
    totalDimenSi < 0.11
      ? 5
      : totalDimenSi >= 0.11 && totalDimenSi < 0.22
      ? 20
      : totalDimenSi >= 0.22 && totalDimenSi < 0.33
      ? 35
      : totalDimenSi >= 0.33 && totalDimenSi < 0.44
      ? 45
      : totalDimenSi >= 0.44 && totalDimenSi < 0.56
      ? 55
      : totalDimenSi >= 0.56 && totalDimenSi < 0.67
      ? 65
      : totalDimenSi >= 0.67 && totalDimenSi < 0.78
      ? 70
      : totalDimenSi >= 0.78 && totalDimenSi < 1.0
      ? 80
      : totalDimenSi >= 1.0 && totalDimenSi < 1.11
      ? 85
      : totalDimenSi >= 1.11 && totalDimenSi < 1.45
      ? 90
      : totalDimenSi >= 1.45 && totalDimenSi < 1.67
      ? 95
      : totalDimenSi >= 1.67 && totalDimenSi < 2.07
      ? 97
      : totalDimenSi >= 2.07
      ? 99
      : "";

  // Sumatorio de valores de respuestas DEP

  const totalSumDep =
    (parseInt(scl90Preg005) || 0) +
    (parseInt(scl90Preg014) || 0) +
    (parseInt(scl90Preg015) || 0) +
    (parseInt(scl90Preg020) || 0) +
    (parseInt(scl90Preg022) || 0) +
    (parseInt(scl90Preg026) || 0) +
    (parseInt(scl90Preg029) || 0) +
    (parseInt(scl90Preg030) || 0) +
    (parseInt(scl90Preg031) || 0) +
    (parseInt(scl90Preg032) || 0) +
    (parseInt(scl90Preg054) || 0) +
    (parseInt(scl90Preg071) || 0) +
    (parseInt(scl90Preg079) || 0);

  // Contador respuestas seleccionadas DEP

  const countSelectedResponsesDep = () => {
    let count = 0;

    if (scl90Preg005 !== "") {
      count++;
    }
    if (scl90Preg014 !== "") {
      count++;
    }
    if (scl90Preg015 !== "") {
      count++;
    }
    if (scl90Preg020 !== "") {
      count++;
    }
    if (scl90Preg022 !== "") {
      count++;
    }
    if (scl90Preg026 !== "") {
      count++;
    }
    if (scl90Preg029 !== "") {
      count++;
    }
    if (scl90Preg030 !== "") {
      count++;
    }
    if (scl90Preg031 !== "") {
      count++;
    }
    if (scl90Preg032 !== "") {
      count++;
    }
    if (scl90Preg054 !== "") {
      count++;
    }
    if (scl90Preg071 !== "") {
      count++;
    }
    if (scl90Preg079 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores DEP y respuestas seleccionadas DEP

  const totalDimenDep = (
    totalSumDep / countSelectedResponsesDep() || 0
  ).toFixed(2);

  // Calculo baremo percentil DEP

  const percDepHomb =
    totalDimenDep < 0.15
      ? 5
      : totalDimenDep >= 0.15 && totalDimenDep < 0.2
      ? 10
      : totalDimenDep >= 0.2 && totalDimenDep < 0.23
      ? 20
      : totalDimenDep >= 0.23 && totalDimenDep < 0.31
      ? 25
      : totalDimenDep >= 0.31 && totalDimenDep < 0.38
      ? 30
      : totalDimenDep >= 0.38 && totalDimenDep < 0.4
      ? 35
      : totalDimenDep >= 0.4 && totalDimenDep < 0.46
      ? 40
      : totalDimenDep >= 0.46 && totalDimenDep < 0.54
      ? 45
      : totalDimenDep >= 0.54 && totalDimenDep < 0.62
      ? 55
      : totalDimenDep >= 0.62 && totalDimenDep < 0.65
      ? 60
      : totalDimenDep >= 0.65 && totalDimenDep < 0.77
      ? 65
      : totalDimenDep >= 0.77 && totalDimenDep < 0.85
      ? 70
      : totalDimenDep >= 0.85 && totalDimenDep < 0.92
      ? 75
      : totalDimenDep >= 0.92 && totalDimenDep < 1.08
      ? 80
      : totalDimenDep >= 1.08 && totalDimenDep < 1.21
      ? 85
      : totalDimenDep >= 1.21 && totalDimenDep < 1.54
      ? 90
      : totalDimenDep >= 1.54 && totalDimenDep < 1.72
      ? 95
      : totalDimenDep >= 1.72 && totalDimenDep < 1.92
      ? 97
      : totalDimenDep >= 1.92
      ? 99
      : "";

  const percDepMuj =
    totalDimenDep < 0.08
      ? 0
      : totalDimenDep >= 0.08 && totalDimenDep < 0.15
      ? 5
      : totalDimenDep >= 0.15 && totalDimenDep < 0.23
      ? 10
      : totalDimenDep >= 0.23 && totalDimenDep < 0.31
      ? 15
      : totalDimenDep >= 0.31 && totalDimenDep < 0.38
      ? 20
      : totalDimenDep >= 0.38 && totalDimenDep < 0.44
      ? 25
      : totalDimenDep >= 0.44 && totalDimenDep < 0.54
      ? 30
      : totalDimenDep >= 0.54 && totalDimenDep < 0.62
      ? 35
      : totalDimenDep >= 0.62 && totalDimenDep < 0.69
      ? 40
      : totalDimenDep >= 0.69 && totalDimenDep < 0.77
      ? 45
      : totalDimenDep >= 0.77 && totalDimenDep < 0.92
      ? 50
      : totalDimenDep >= 0.92 && totalDimenDep < 1.0
      ? 60
      : totalDimenDep >= 1.0 && totalDimenDep < 1.08
      ? 65
      : totalDimenDep >= 1.08 && totalDimenDep < 1.15
      ? 70
      : totalDimenDep >= 1.15 && totalDimenDep < 1.23
      ? 75
      : totalDimenDep >= 1.23 && totalDimenDep < 1.4
      ? 80
      : totalDimenDep >= 1.4 && totalDimenDep < 1.69
      ? 85
      : totalDimenDep >= 1.69 && totalDimenDep < 2.0
      ? 90
      : totalDimenDep >= 2.0 && totalDimenDep < 2.25
      ? 95
      : totalDimenDep >= 2.25 && totalDimenDep < 2.72
      ? 97
      : totalDimenDep >= 2.72
      ? 99
      : "";

  // Sumatorio de valores de respuestas ANS

  const totalSumAns =
    (parseInt(scl90Preg002) || 0) +
    (parseInt(scl90Preg017) || 0) +
    (parseInt(scl90Preg023) || 0) +
    (parseInt(scl90Preg033) || 0) +
    (parseInt(scl90Preg039) || 0) +
    (parseInt(scl90Preg057) || 0) +
    (parseInt(scl90Preg072) || 0) +
    (parseInt(scl90Preg078) || 0) +
    (parseInt(scl90Preg080) || 0) +
    (parseInt(scl90Preg086) || 0);

  // Contador respuestas seleccionadas ANS

  const countSelectedResponsesAns = () => {
    let count = 0;

    if (scl90Preg002 !== "") {
      count++;
    }
    if (scl90Preg017 !== "") {
      count++;
    }
    if (scl90Preg023 !== "") {
      count++;
    }
    if (scl90Preg033 !== "") {
      count++;
    }
    if (scl90Preg039 !== "") {
      count++;
    }
    if (scl90Preg057 !== "") {
      count++;
    }
    if (scl90Preg072 !== "") {
      count++;
    }
    if (scl90Preg078 !== "") {
      count++;
    }
    if (scl90Preg080 !== "") {
      count++;
    }
    if (scl90Preg086 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores ANS y respuestas seleccionadas ANS

  const totalDimenAns = (
    totalSumAns / countSelectedResponsesAns() || 0
  ).toFixed(2);

  // Calculo baremo percentil ANS

  const percAnsHomb =
    totalDimenAns < 0.1
      ? 5
      : totalDimenAns >= 0.1 && totalDimenAns < 0.2
      ? 15
      : totalDimenAns >= 0.2 && totalDimenAns < 0.3
      ? 30
      : totalDimenAns >= 0.3 && totalDimenAns < 0.4
      ? 45
      : totalDimenAns >= 0.4 && totalDimenAns < 0.5
      ? 55
      : totalDimenAns >= 0.5 && totalDimenAns < 0.6
      ? 65
      : totalDimenAns >= 0.6 && totalDimenAns < 0.7
      ? 75
      : totalDimenAns >= 0.7 && totalDimenAns < 0.8
      ? 80
      : totalDimenAns >= 0.8 && totalDimenAns < 0.9
      ? 85
      : totalDimenAns >= 0.9 && totalDimenAns < 1.2
      ? 90
      : totalDimenAns >= 1.2 && totalDimenAns < 1.34
      ? 95
      : totalDimenAns >= 1.34 && totalDimenAns < 2.05
      ? 97
      : totalDimenAns >= 2.05
      ? 99
      : "";

  const percAnsMuj =
    totalDimenAns < 0.1
      ? 5
      : totalDimenAns >= 0.1 && totalDimenAns < 0.2
      ? 15
      : totalDimenAns >= 0.2 && totalDimenAns < 0.3
      ? 25
      : totalDimenAns >= 0.3 && totalDimenAns < 0.4
      ? 30
      : totalDimenAns >= 0.4 && totalDimenAns < 0.5
      ? 45
      : totalDimenAns >= 0.5 && totalDimenAns < 0.6
      ? 55
      : totalDimenAns >= 0.6 && totalDimenAns < 0.7
      ? 60
      : totalDimenAns >= 0.7 && totalDimenAns < 0.8
      ? 70
      : totalDimenAns >= 0.8 && totalDimenAns < 0.9
      ? 75
      : totalDimenAns >= 0.9 && totalDimenAns < 1.1
      ? 80
      : totalDimenAns >= 1.1 && totalDimenAns < 1.3
      ? 85
      : totalDimenAns >= 1.3 && totalDimenAns < 1.7
      ? 90
      : totalDimenAns >= 1.7 && totalDimenAns < 2.06
      ? 95
      : totalDimenAns >= 2.06 && totalDimenAns < 2.43
      ? 97
      : totalDimenAns >= 2.43
      ? 99
      : "";

  // Sumatorio de valores de respuestas HOS

  const totalSumHos =
    (parseInt(scl90Preg011) || 0) +
    (parseInt(scl90Preg024) || 0) +
    (parseInt(scl90Preg063) || 0) +
    (parseInt(scl90Preg067) || 0) +
    (parseInt(scl90Preg074) || 0) +
    (parseInt(scl90Preg081) || 0);

  // Contador respuestas seleccionadas HOS

  const countSelectedResponsesHos = () => {
    let count = 0;

    if (scl90Preg011 !== "") {
      count++;
    }
    if (scl90Preg024 !== "") {
      count++;
    }
    if (scl90Preg063 !== "") {
      count++;
    }
    if (scl90Preg067 !== "") {
      count++;
    }
    if (scl90Preg074 !== "") {
      count++;
    }
    if (scl90Preg081 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores HOS y respuestas seleccionadas HOS

  const totalDimenHos = (
    totalSumHos / countSelectedResponsesHos() || 0
  ).toFixed(2);

  // Calculo baremo percentil HOS

  const percHosHomb =
    totalDimenHos < 0.17
      ? 5
      : totalDimenHos >= 0.17 && totalDimenHos < 0.25
      ? 35
      : totalDimenHos >= 0.25 && totalDimenHos < 0.33
      ? 50
      : totalDimenHos >= 0.33 && totalDimenHos < 0.5
      ? 55
      : totalDimenHos >= 0.5 && totalDimenHos < 0.52
      ? 65
      : totalDimenHos >= 0.52 && totalDimenHos < 0.67
      ? 70
      : totalDimenHos >= 0.67 && totalDimenHos < 0.83
      ? 75
      : totalDimenHos >= 0.83 && totalDimenHos < 1.0
      ? 80
      : totalDimenHos >= 1.0 && totalDimenHos < 1.17
      ? 85
      : totalDimenHos >= 1.17 && totalDimenHos < 1.5
      ? 90
      : totalDimenHos >= 1.5 && totalDimenHos < 2.16
      ? 95
      : totalDimenHos >= 2.16
      ? 99
      : "";


  const percHosMuj =
    totalDimenHos < 0.17
      ? 5
      : totalDimenHos >= 0.17 && totalDimenHos < 0.33
      ? 35
      : totalDimenHos >= 0.33 && totalDimenHos < 0.5
      ? 45
      : totalDimenHos >= 0.5 && totalDimenHos < 0.67
      ? 60
      : totalDimenHos >= 0.67 && totalDimenHos < 0.83
      ? 70
      : totalDimenHos >= 0.83 && totalDimenHos < 1.0
      ? 80
      : totalDimenHos >= 1.0 && totalDimenHos < 1.33
      ? 85
      : totalDimenHos >= 1.33 && totalDimenHos < 1.83
      ? 90
      : totalDimenHos >= 1.83 && totalDimenHos < 2.0
      ? 95
      : totalDimenHos >= 2.0 && totalDimenHos < 2.54
      ? 97
      : totalDimenHos >= 2.54
      ? 99
      : "";

  // Sumatorio de valores de respuestas FOB

  const totalSumFob =
    (parseInt(scl90Preg013) || 0) +
    (parseInt(scl90Preg025) || 0) +
    (parseInt(scl90Preg047) || 0) +
    (parseInt(scl90Preg050) || 0) +
    (parseInt(scl90Preg070) || 0) +
    (parseInt(scl90Preg075) || 0) +
    (parseInt(scl90Preg082) || 0);

  // Contador respuestas seleccionadas FOB

  const countSelectedResponsesFob = () => {
    let count = 0;

    if (scl90Preg013 !== "") {
      count++;
    }
    if (scl90Preg025 !== "") {
      count++;
    }
    if (scl90Preg047 !== "") {
      count++;
    }
    if (scl90Preg050 !== "") {
      count++;
    }
    if (scl90Preg070 !== "") {
      count++;
    }
    if (scl90Preg075 !== "") {
      count++;
    }
    if (scl90Preg082 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores FOB y respuestas seleccionadas FOB

  const totalDimenFob = (
    totalSumFob / countSelectedResponsesFob() || 0
  ).toFixed(2);

  // Calculo baremo percentil FOB

  const percFobHomb =
    totalDimenFob < 0.14
      ? 5
      : totalDimenFob >= 0.14 && totalDimenFob < 0.29
      ? 50
      : totalDimenFob >= 0.29 && totalDimenFob < 0.43
      ? 70
      : totalDimenFob >= 0.43 && totalDimenFob < 0.57
      ? 80
      : totalDimenFob >= 0.57 && totalDimenFob < 0.71
      ? 90
      : totalDimenFob >= 0.71 && totalDimenFob < 0.86
      ? 95
      : totalDimenFob >= 0.86 && totalDimenFob < 1.29
      ? 97
      : totalDimenFob >= 1.29
      ? 99
      : "";

  const percFobMuj =
    totalDimenFob < 0.14
      ? 5
      : totalDimenFob >= 0.14 && totalDimenFob < 0.29
      ? 45
      : totalDimenFob >= 0.29 && totalDimenFob < 0.43
      ? 60
      : totalDimenFob >= 0.43 && totalDimenFob < 0.57
      ? 70
      : totalDimenFob >= 0.57 && totalDimenFob < 0.71
      ? 80
      : totalDimenFob >= 0.71 && totalDimenFob < 0.87
      ? 85
      : totalDimenFob >= 0.87 && totalDimenFob < 1.29
      ? 90
      : totalDimenFob >= 1.29 && totalDimenFob < 1.43
      ? 95
      : totalDimenFob >= 1.43 && totalDimenFob < 2.17
      ? 97
      : totalDimenFob >= 2.17
      ? 99
      : "";

  // Sumatorio de valores de respuestas PAR

  const totalSumPar =
    (parseInt(scl90Preg008) || 0) +
    (parseInt(scl90Preg018) || 0) +
    (parseInt(scl90Preg043) || 0) +
    (parseInt(scl90Preg068) || 0) +
    (parseInt(scl90Preg076) || 0) +
    (parseInt(scl90Preg083) || 0);

  // Contador respuestas seleccionadas PAR

  const countSelectedResponsesPar = () => {
    let count = 0;

    if (scl90Preg008 !== "") {
      count++;
    }
    if (scl90Preg018 !== "") {
      count++;
    }
    if (scl90Preg043 !== "") {
      count++;
    }
    if (scl90Preg068 !== "") {
      count++;
    }
    if (scl90Preg076 !== "") {
      count++;
    }
    if (scl90Preg083 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores PAR y respuestas seleccionadas PAR

  const totalDimenPar = (
    totalSumPar / countSelectedResponsesPar() || 0
  ).toFixed(2);

  // Calculo baremo percentil PAR

  const percParHomb =
    totalDimenPar < 0.17
      ? 5
      : totalDimenPar >= 0.17 && totalDimenPar < 0.33
      ? 30
      : totalDimenPar >= 0.33 && totalDimenPar < 0.5
      ? 40
      : totalDimenPar >= 0.5 && totalDimenPar < 0.67
      ? 55
      : totalDimenPar >= 0.67 && totalDimenPar < 0.83
      ? 70
      : totalDimenPar >= 0.83 && totalDimenPar < 1.0
      ? 80
      : totalDimenPar >= 1.0 && totalDimenPar < 1.17
      ? 85
      : totalDimenPar >= 1.17 && totalDimenPar < 1.33
      ? 90
      : totalDimenPar >= 1.33 && totalDimenPar < 1.5
      ? 95
      : totalDimenPar >= 1.5 && totalDimenPar < 2.0
      ? 97
      : totalDimenPar >= 2.0
      ? 99
      : "";

  const percParMuj =
    totalDimenPar < 0.17
      ? 5
      : totalDimenPar >= 0.17 && totalDimenPar < 0.33
      ? 45
      : totalDimenPar >= 0.33 && totalDimenPar < 0.5
      ? 50
      : totalDimenPar >= 0.5 && totalDimenPar < 0.67
      ? 60
      : totalDimenPar >= 0.67 && totalDimenPar < 0.83
      ? 70
      : totalDimenPar >= 0.83 && totalDimenPar < 1.0
      ? 80
      : totalDimenPar >= 1.0 && totalDimenPar < 1.17
      ? 85
      : totalDimenPar >= 1.17 && totalDimenPar < 1.35
      ? 90
      : totalDimenPar >= 1.35 && totalDimenPar < 2.0
      ? 95
      : totalDimenPar >= 2.0 && totalDimenPar < 2.4
      ? 97
      : totalDimenPar >= 2.4
      ? 99
      : "";

  // Sumatorio de valores de respuestas PSI

  const totalSumPsic =
    (parseInt(scl90Preg007) || 0) +
    (parseInt(scl90Preg016) || 0) +
    (parseInt(scl90Preg035) || 0) +
    (parseInt(scl90Preg062) || 0) +
    (parseInt(scl90Preg077) || 0) +
    (parseInt(scl90Preg084) || 0) +
    (parseInt(scl90Preg085) || 0) +
    (parseInt(scl90Preg087) || 0) +
    (parseInt(scl90Preg088) || 0) +
    (parseInt(scl90Preg090) || 0);

  // Contador respuestas seleccionadas PSI

  const countSelectedResponsesPsic = () => {
    let count = 0;

    if (scl90Preg007 !== "") {
      count++;
    }
    if (scl90Preg016 !== "") {
      count++;
    }
    if (scl90Preg035 !== "") {
      count++;
    }
    if (scl90Preg062 !== "") {
      count++;
    }
    if (scl90Preg077 !== "") {
      count++;
    }
    if (scl90Preg084 !== "") {
      count++;
    }
    if (scl90Preg085 !== "") {
      count++;
    }
    if (scl90Preg087 !== "") {
      count++;
    }
    if (scl90Preg088 !== "") {
      count++;
    }
    if (scl90Preg090 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores PSI y respuestas seleccionadas PSI

  const totalDimenPsic = (
    totalSumPsic / countSelectedResponsesPsic() || 0
  ).toFixed(2);

  // Calculo baremo percentil PSI

  const percPsicHomb =
    totalDimenPsic < 0.1
      ? 5
      : totalDimenPsic >= 0.1 && totalDimenPsic < 0.2
      ? 45
      : totalDimenPsic >= 0.2 && totalDimenPsic < 0.3
      ? 60
      : totalDimenPsic >= 0.3 && totalDimenPsic < 0.4
      ? 75
      : totalDimenPsic >= 0.4 && totalDimenPsic < 0.51
      ? 80
      : totalDimenPsic >= 0.51 && totalDimenPsic < 0.7
      ? 85
      : totalDimenPsic >= 0.7 && totalDimenPsic < 0.83
      ? 90
      : totalDimenPsic >= 0.83 && totalDimenPsic < 1.0
      ? 95
      : totalDimenPsic >= 1.0 && totalDimenPsic < 1.1
      ? 97
      : totalDimenPsic >= 1.1
      ? 99
      : "";

  const percPsicMuj =
    totalDimenPsic < 0.06
      ? 5
      : totalDimenPsic >= 0.06 && totalDimenPsic < 0.1
      ? 40
      : totalDimenPsic >= 0.1 && totalDimenPsic < 0.2
      ? 45
      : totalDimenPsic >= 0.2 && totalDimenPsic < 0.3
      ? 60
      : totalDimenPsic >= 0.3 && totalDimenPsic < 0.4
      ? 70
      : totalDimenPsic >= 0.4 && totalDimenPsic < 0.5
      ? 80
      : totalDimenPsic >= 0.5 && totalDimenPsic < 0.7
      ? 85
      : totalDimenPsic >= 0.7 && totalDimenPsic < 0.9
      ? 90
      : totalDimenPsic >= 0.9 && totalDimenPsic < 1.2
      ? 95
      : totalDimenPsic >= 1.2 && totalDimenPsic < 1.42
      ? 97
      : totalDimenPsic >= 1.42
      ? 99
      : "";

  // Sumatorio de valores de respuestas ADI

  const totalSumAdi =
    (parseInt(scl90Preg019) || 0) +
    (parseInt(scl90Preg044) || 0) +
    (parseInt(scl90Preg059) || 0) +
    (parseInt(scl90Preg060) || 0) +
    (parseInt(scl90Preg064) || 0) +
    (parseInt(scl90Preg066) || 0) +
    (parseInt(scl90Preg089) || 0);

  // Contador respuestas seleccionadas ADI

  const countSelectedResponsesAdi = () => {
    let count = 0;

    if (scl90Preg019 !== "") {
      count++;
    }
    if (scl90Preg044 !== "") {
      count++;
    }
    if (scl90Preg059 !== "") {
      count++;
    }
    if (scl90Preg060 !== "") {
      count++;
    }
    if (scl90Preg064 !== "") {
      count++;
    }
    if (scl90Preg066 !== "") {
      count++;
    }
    if (scl90Preg089 !== "") {
      count++;
    }

    return count;
  };

  // Calculo entre sumatorio valores ADI y respuestas seleccionadas ADI

  const totalDimenAdi = (
    totalSumAdi / countSelectedResponsesAdi() || 0
  ).toFixed(2);

  // Suma de todas las puntuaciones

  const totalSumScl =
    (parseInt(scl90Preg001) || 0) +
    (parseInt(scl90Preg002) || 0) +
    (parseInt(scl90Preg003) || 0) +
    (parseInt(scl90Preg004) || 0) +
    (parseInt(scl90Preg005) || 0) +
    (parseInt(scl90Preg006) || 0) +
    (parseInt(scl90Preg007) || 0) +
    (parseInt(scl90Preg008) || 0) +
    (parseInt(scl90Preg009) || 0) +
    (parseInt(scl90Preg010) || 0) +
    (parseInt(scl90Preg011) || 0) +
    (parseInt(scl90Preg012) || 0) +
    (parseInt(scl90Preg013) || 0) +
    (parseInt(scl90Preg014) || 0) +
    (parseInt(scl90Preg015) || 0) +
    (parseInt(scl90Preg016) || 0) +
    (parseInt(scl90Preg017) || 0) +
    (parseInt(scl90Preg018) || 0) +
    (parseInt(scl90Preg019) || 0) +
    (parseInt(scl90Preg020) || 0) +
    (parseInt(scl90Preg021) || 0) +
    (parseInt(scl90Preg022) || 0) +
    (parseInt(scl90Preg023) || 0) +
    (parseInt(scl90Preg024) || 0) +
    (parseInt(scl90Preg025) || 0) +
    (parseInt(scl90Preg026) || 0) +
    (parseInt(scl90Preg027) || 0) +
    (parseInt(scl90Preg028) || 0) +
    (parseInt(scl90Preg029) || 0) +
    (parseInt(scl90Preg030) || 0) +
    (parseInt(scl90Preg031) || 0) +
    (parseInt(scl90Preg032) || 0) +
    (parseInt(scl90Preg033) || 0) +
    (parseInt(scl90Preg034) || 0) +
    (parseInt(scl90Preg035) || 0) +
    (parseInt(scl90Preg036) || 0) +
    (parseInt(scl90Preg037) || 0) +
    (parseInt(scl90Preg038) || 0) +
    (parseInt(scl90Preg039) || 0) +
    (parseInt(scl90Preg040) || 0) +
    (parseInt(scl90Preg041) || 0) +
    (parseInt(scl90Preg042) || 0) +
    (parseInt(scl90Preg043) || 0) +
    (parseInt(scl90Preg044) || 0) +
    (parseInt(scl90Preg045) || 0) +
    (parseInt(scl90Preg046) || 0) +
    (parseInt(scl90Preg047) || 0) +
    (parseInt(scl90Preg048) || 0) +
    (parseInt(scl90Preg049) || 0) +
    (parseInt(scl90Preg050) || 0) +
    (parseInt(scl90Preg051) || 0) +
    (parseInt(scl90Preg052) || 0) +
    (parseInt(scl90Preg053) || 0) +
    (parseInt(scl90Preg054) || 0) +
    (parseInt(scl90Preg055) || 0) +
    (parseInt(scl90Preg056) || 0) +
    (parseInt(scl90Preg057) || 0) +
    (parseInt(scl90Preg058) || 0) +
    (parseInt(scl90Preg059) || 0) +
    (parseInt(scl90Preg060) || 0) +
    (parseInt(scl90Preg061) || 0) +
    (parseInt(scl90Preg062) || 0) +
    (parseInt(scl90Preg063) || 0) +
    (parseInt(scl90Preg064) || 0) +
    (parseInt(scl90Preg065) || 0) +
    (parseInt(scl90Preg066) || 0) +
    (parseInt(scl90Preg067) || 0) +
    (parseInt(scl90Preg068) || 0) +
    (parseInt(scl90Preg069) || 0) +
    (parseInt(scl90Preg070) || 0) +
    (parseInt(scl90Preg071) || 0) +
    (parseInt(scl90Preg072) || 0) +
    (parseInt(scl90Preg073) || 0) +
    (parseInt(scl90Preg074) || 0) +
    (parseInt(scl90Preg075) || 0) +
    (parseInt(scl90Preg076) || 0) +
    (parseInt(scl90Preg077) || 0) +
    (parseInt(scl90Preg078) || 0) +
    (parseInt(scl90Preg079) || 0) +
    (parseInt(scl90Preg080) || 0) +
    (parseInt(scl90Preg081) || 0) +
    (parseInt(scl90Preg082) || 0) +
    (parseInt(scl90Preg083) || 0) +
    (parseInt(scl90Preg084) || 0) +
    (parseInt(scl90Preg085) || 0) +
    (parseInt(scl90Preg086) || 0) +
    (parseInt(scl90Preg087) || 0) +
    (parseInt(scl90Preg088) || 0) +
    (parseInt(scl90Preg089) || 0) +
    (parseInt(scl90Preg090) || 0);

  // Numero de respuestas dadas

  const countSelectedResponsesScl = () => {
    let count = 0;

    if (scl90Preg001 !== "") {
      count++;
    }
    if (scl90Preg002 !== "") {
      count++;
    }
    if (scl90Preg003 !== "") {
      count++;
    }
    if (scl90Preg004 !== "") {
      count++;
    }
    if (scl90Preg005 !== "") {
      count++;
    }
    if (scl90Preg006 !== "") {
      count++;
    }
    if (scl90Preg007 !== "") {
      count++;
    }
    if (scl90Preg008 !== "") {
      count++;
    }
    if (scl90Preg009 !== "") {
      count++;
    }
    if (scl90Preg010 !== "") {
      count++;
    }
    if (scl90Preg011 !== "") {
      count++;
    }
    if (scl90Preg012 !== "") {
      count++;
    }
    if (scl90Preg013 !== "") {
      count++;
    }
    if (scl90Preg014 !== "") {
      count++;
    }
    if (scl90Preg015 !== "") {
      count++;
    }
    if (scl90Preg016 !== "") {
      count++;
    }
    if (scl90Preg017 !== "") {
      count++;
    }
    if (scl90Preg018 !== "") {
      count++;
    }
    if (scl90Preg019 !== "") {
      count++;
    }
    if (scl90Preg020 !== "") {
      count++;
    }
    if (scl90Preg021 !== "") {
      count++;
    }
    if (scl90Preg022 !== "") {
      count++;
    }
    if (scl90Preg023 !== "") {
      count++;
    }
    if (scl90Preg024 !== "") {
      count++;
    }
    if (scl90Preg025 !== "") {
      count++;
    }
    if (scl90Preg026 !== "") {
      count++;
    }
    if (scl90Preg027 !== "") {
      count++;
    }
    if (scl90Preg028 !== "") {
      count++;
    }
    if (scl90Preg029 !== "") {
      count++;
    }
    if (scl90Preg030 !== "") {
      count++;
    }
    if (scl90Preg031 !== "") {
      count++;
    }
    if (scl90Preg032 !== "") {
      count++;
    }
    if (scl90Preg033 !== "") {
      count++;
    }
    if (scl90Preg034 !== "") {
      count++;
    }
    if (scl90Preg035 !== "") {
      count++;
    }
    if (scl90Preg036 !== "") {
      count++;
    }
    if (scl90Preg037 !== "") {
      count++;
    }
    if (scl90Preg038 !== "") {
      count++;
    }
    if (scl90Preg039 !== "") {
      count++;
    }
    if (scl90Preg040 !== "") {
      count++;
    }
    if (scl90Preg041 !== "") {
      count++;
    }
    if (scl90Preg042 !== "") {
      count++;
    }
    if (scl90Preg043 !== "") {
      count++;
    }
    if (scl90Preg044 !== "") {
      count++;
    }
    if (scl90Preg045 !== "") {
      count++;
    }
    if (scl90Preg046 !== "") {
      count++;
    }
    if (scl90Preg047 !== "") {
      count++;
    }
    if (scl90Preg048 !== "") {
      count++;
    }
    if (scl90Preg049 !== "") {
      count++;
    }
    if (scl90Preg050 !== "") {
      count++;
    }
    if (scl90Preg051 !== "") {
      count++;
    }
    if (scl90Preg052 !== "") {
      count++;
    }
    if (scl90Preg053 !== "") {
      count++;
    }
    if (scl90Preg054 !== "") {
      count++;
    }
    if (scl90Preg055 !== "") {
      count++;
    }
    if (scl90Preg056 !== "") {
      count++;
    }
    if (scl90Preg057 !== "") {
      count++;
    }
    if (scl90Preg058 !== "") {
      count++;
    }
    if (scl90Preg059 !== "") {
      count++;
    }
    if (scl90Preg060 !== "") {
      count++;
    }
    if (scl90Preg061 !== "") {
      count++;
    }
    if (scl90Preg062 !== "") {
      count++;
    }
    if (scl90Preg063 !== "") {
      count++;
    }
    if (scl90Preg064 !== "") {
      count++;
    }
    if (scl90Preg065 !== "") {
      count++;
    }
    if (scl90Preg066 !== "") {
      count++;
    }
    if (scl90Preg067 !== "") {
      count++;
    }
    if (scl90Preg068 !== "") {
      count++;
    }
    if (scl90Preg069 !== "") {
      count++;
    }
    if (scl90Preg070 !== "") {
      count++;
    }
    if (scl90Preg071 !== "") {
      count++;
    }
    if (scl90Preg072 !== "") {
      count++;
    }
    if (scl90Preg073 !== "") {
      count++;
    }
    if (scl90Preg074 !== "") {
      count++;
    }
    if (scl90Preg075 !== "") {
      count++;
    }
    if (scl90Preg076 !== "") {
      count++;
    }
    if (scl90Preg077 !== "") {
      count++;
    }
    if (scl90Preg078 !== "") {
      count++;
    }
    if (scl90Preg079 !== "") {
      count++;
    }
    if (scl90Preg080 !== "") {
      count++;
    }
    if (scl90Preg081 !== "") {
      count++;
    }
    if (scl90Preg082 !== "") {
      count++;
    }
    if (scl90Preg083 !== "") {
      count++;
    }
    if (scl90Preg084 !== "") {
      count++;
    }
    if (scl90Preg085 !== "") {
      count++;
    }
    if (scl90Preg086 !== "") {
      count++;
    }
    if (scl90Preg087 !== "") {
      count++;
    }
    if (scl90Preg088 !== "") {
      count++;
    }
    if (scl90Preg089 !== "") {
      count++;
    }
    if (scl90Preg090 !== "") {
      count++;
    }
    return count;
  };

  // Calculo de GSI

  const resultGsi = (
    parseInt(totalSumScl) / parseInt(countSelectedResponsesScl())
  ).toFixed(2);


  // Calculo baremo percentil GSI

  const percGsiHomb =
    resultGsi < 0.08
      ? 0
      : resultGsi >= 0.08 && resultGsi < 0.13
      ? 5
      : resultGsi >= 0.13 && resultGsi < 0.17
      ? 10
      : resultGsi >= 0.17 && resultGsi < 0.19
      ? 15
      : resultGsi >= 0.19 && resultGsi < 0.22
      ? 20
      : resultGsi >= 0.22 && resultGsi < 0.24
      ? 25
      : resultGsi >= 0.24 && resultGsi < 0.27
      ? 30
      : resultGsi >= 0.27 && resultGsi < 0.3
      ? 35
      : resultGsi >= 0.3 && resultGsi < 0.34
      ? 40
      : resultGsi >= 0.34 && resultGsi < 0.38
      ? 45
      : resultGsi >= 0.38 && resultGsi < 0.41
      ? 50
      : resultGsi >= 0.41 && resultGsi < 0.44
      ? 55
      : resultGsi >= 0.44 && resultGsi < 0.48
      ? 60
      : resultGsi >= 0.48 && resultGsi < 0.54
      ? 65
      : resultGsi >= 0.54 && resultGsi < 0.59
      ? 70
      : resultGsi >= 0.59 && resultGsi < 0.63
      ? 75
      : resultGsi >= 0.63 && resultGsi < 0.73
      ? 80
      : resultGsi >= 0.73 && resultGsi < 0.8
      ? 85
      : resultGsi >= 0.8 && resultGsi < 1.08
      ? 90
      : resultGsi >= 1.08 && resultGsi < 1.16
      ? 95
      : resultGsi >= 1.16 && resultGsi < 1.44
      ? 97
      : resultGsi >= 1.44
      ? 99
      : "";

  const percGsiMuj =
    resultGsi < 0.08
      ? 0
      : resultGsi >= 0.08 && resultGsi < 0.14
      ? 5
      : resultGsi >= 0.14 && resultGsi < 0.2
      ? 10
      : resultGsi >= 0.2 && resultGsi < 0.24
      ? 15
      : resultGsi >= 0.24 && resultGsi < 0.29
      ? 20
      : resultGsi >= 0.29 && resultGsi < 0.33
      ? 25
      : resultGsi >= 0.33 && resultGsi < 0.38
      ? 30
      : resultGsi >= 0.38 && resultGsi < 0.42
      ? 35
      : resultGsi >= 0.42 && resultGsi < 0.46
      ? 40
      : resultGsi >= 0.46 && resultGsi < 0.5
      ? 45
      : resultGsi >= 0.5 && resultGsi < 0.54
      ? 50
      : resultGsi >= 0.54 && resultGsi < 0.59
      ? 55
      : resultGsi >= 0.59 && resultGsi < 0.64
      ? 60
      : resultGsi >= 0.64 && resultGsi < 0.68
      ? 65
      : resultGsi >= 0.68 && resultGsi < 0.71
      ? 70
      : resultGsi >= 0.71 && resultGsi < 0.77
      ? 75
      : resultGsi >= 0.77 && resultGsi < 0.91
      ? 80
      : resultGsi >= 0.91 && resultGsi < 1.12
      ? 85
      : resultGsi >= 1.12 && resultGsi < 1.47
      ? 90
      : resultGsi >= 1.47 && resultGsi < 1.63
      ? 95
      : resultGsi >= 1.63 && resultGsi < 1.95
      ? 97
      : resultGsi >= 1.95
      ? 99
      : "";

  // Numero de respuestas con valor mayor a cero

  const countNonZeroOrEmptyRespPst = () => {
    let count = 0;

    if (scl90Preg001 !== "0" && scl90Preg001 !== 0 && scl90Preg001 !== "") {
      count++;
    }
    if (scl90Preg002 !== "0" && scl90Preg002 !== 0 && scl90Preg002 !== "") {
      count++;
    }
    if (scl90Preg003 !== "0" && scl90Preg003 !== 0 && scl90Preg003 !== "") {
      count++;
    }
    if (scl90Preg004 !== "0" && scl90Preg004 !== 0 && scl90Preg004 !== "") {
      count++;
    }
    if (scl90Preg005 !== "0" && scl90Preg005 !== 0 && scl90Preg005 !== "") {
      count++;
    }
    if (scl90Preg006 !== "0" && scl90Preg006 !== 0 && scl90Preg006 !== "") {
      count++;
    }
    if (scl90Preg007 !== "0" && scl90Preg007 !== 0 && scl90Preg007 !== "") {
      count++;
    }
    if (scl90Preg008 !== "0" && scl90Preg008 !== 0 && scl90Preg008 !== "") {
      count++;
    }
    if (scl90Preg009 !== "0" && scl90Preg009 !== 0 && scl90Preg009 !== "") {
      count++;
    }
    if (scl90Preg010 !== "0" && scl90Preg010 !== 0 && scl90Preg010 !== "") {
      count++;
    }
    if (scl90Preg011 !== "0" && scl90Preg011 !== 0 && scl90Preg011 !== "") {
      count++;
    }
    if (scl90Preg012 !== "0" && scl90Preg012 !== 0 && scl90Preg012 !== "") {
      count++;
    }
    if (scl90Preg013 !== "0" && scl90Preg013 !== 0 && scl90Preg013 !== "") {
      count++;
    }
    if (scl90Preg014 !== "0" && scl90Preg014 !== 0 && scl90Preg014 !== "") {
      count++;
    }
    if (scl90Preg015 !== "0" && scl90Preg015 !== 0 && scl90Preg015 !== "") {
      count++;
    }
    if (scl90Preg016 !== "0" && scl90Preg016 !== 0 && scl90Preg016 !== "") {
      count++;
    }
    if (scl90Preg017 !== "0" && scl90Preg017 !== 0 && scl90Preg017 !== "") {
      count++;
    }
    if (scl90Preg018 !== "0" && scl90Preg018 !== 0 && scl90Preg018 !== "") {
      count++;
    }
    if (scl90Preg019 !== "0" && scl90Preg019 !== 0 && scl90Preg019 !== "") {
      count++;
    }
    if (scl90Preg020 !== "0" && scl90Preg020 !== 0 && scl90Preg020 !== "") {
      count++;
    }
    if (scl90Preg021 !== "0" && scl90Preg021 !== 0 && scl90Preg021 !== "") {
      count++;
    }
    if (scl90Preg022 !== "0" && scl90Preg022 !== 0 && scl90Preg022 !== "") {
      count++;
    }
    if (scl90Preg023 !== "0" && scl90Preg023 !== 0 && scl90Preg023 !== "") {
      count++;
    }
    if (scl90Preg024 !== "0" && scl90Preg024 !== 0 && scl90Preg024 !== "") {
      count++;
    }
    if (scl90Preg025 !== "0" && scl90Preg025 !== 0 && scl90Preg025 !== "") {
      count++;
    }
    if (scl90Preg026 !== "0" && scl90Preg026 !== 0 && scl90Preg026 !== "") {
      count++;
    }
    if (scl90Preg027 !== "0" && scl90Preg027 !== 0 && scl90Preg027 !== "") {
      count++;
    }
    if (scl90Preg028 !== "0" && scl90Preg028 !== 0 && scl90Preg028 !== "") {
      count++;
    }
    if (scl90Preg029 !== "0" && scl90Preg029 !== 0 && scl90Preg029 !== "") {
      count++;
    }
    if (scl90Preg030 !== "0" && scl90Preg030 !== 0 && scl90Preg030 !== "") {
      count++;
    }
    if (scl90Preg031 !== "0" && scl90Preg031 !== 0 && scl90Preg031 !== "") {
      count++;
    }
    if (scl90Preg032 !== "0" && scl90Preg032 !== 0 && scl90Preg032 !== "") {
      count++;
    }
    if (scl90Preg033 !== "0" && scl90Preg033 !== 0 && scl90Preg033 !== "") {
      count++;
    }
    if (scl90Preg034 !== "0" && scl90Preg034 !== 0 && scl90Preg034 !== "") {
      count++;
    }
    if (scl90Preg035 !== "0" && scl90Preg035 !== 0 && scl90Preg035 !== "") {
      count++;
    }
    if (scl90Preg036 !== "0" && scl90Preg036 !== 0 && scl90Preg036 !== "") {
      count++;
    }
    if (scl90Preg037 !== "0" && scl90Preg037 !== 0 && scl90Preg037 !== "") {
      count++;
    }
    if (scl90Preg038 !== "0" && scl90Preg038 !== 0 && scl90Preg038 !== "") {
      count++;
    }
    if (scl90Preg039 !== "0" && scl90Preg039 !== 0 && scl90Preg039 !== "") {
      count++;
    }
    if (scl90Preg040 !== "0" && scl90Preg040 !== 0 && scl90Preg040 !== "") {
      count++;
    }
    if (scl90Preg041 !== "0" && scl90Preg041 !== 0 && scl90Preg041 !== "") {
      count++;
    }
    if (scl90Preg042 !== "0" && scl90Preg042 !== 0 && scl90Preg042 !== "") {
      count++;
    }
    if (scl90Preg043 !== "0" && scl90Preg043 !== 0 && scl90Preg043 !== "") {
      count++;
    }
    if (scl90Preg044 !== "0" && scl90Preg044 !== 0 && scl90Preg044 !== "") {
      count++;
    }
    if (scl90Preg045 !== "0" && scl90Preg045 !== 0 && scl90Preg045 !== "") {
      count++;
    }
    if (scl90Preg046 !== "0" && scl90Preg046 !== 0 && scl90Preg046 !== "") {
      count++;
    }
    if (scl90Preg047 !== "0" && scl90Preg047 !== 0 && scl90Preg047 !== "") {
      count++;
    }
    if (scl90Preg048 !== "0" && scl90Preg048 !== 0 && scl90Preg048 !== "") {
      count++;
    }
    if (scl90Preg049 !== "0" && scl90Preg049 !== 0 && scl90Preg049 !== "") {
      count++;
    }
    if (scl90Preg050 !== "0" && scl90Preg050 !== 0 && scl90Preg050 !== "") {
      count++;
    }
    if (scl90Preg051 !== "0" && scl90Preg051 !== 0 && scl90Preg051 !== "") {
      count++;
    }
    if (scl90Preg052 !== "0" && scl90Preg052 !== 0 && scl90Preg052 !== "") {
      count++;
    }
    if (scl90Preg053 !== "0" && scl90Preg053 !== 0 && scl90Preg053 !== "") {
      count++;
    }
    if (scl90Preg054 !== "0" && scl90Preg054 !== 0 && scl90Preg054 !== "") {
      count++;
    }
    if (scl90Preg055 !== "0" && scl90Preg055 !== 0 && scl90Preg055 !== "") {
      count++;
    }
    if (scl90Preg056 !== "0" && scl90Preg056 !== 0 && scl90Preg056 !== "") {
      count++;
    }
    if (scl90Preg057 !== "0" && scl90Preg057 !== 0 && scl90Preg057 !== "") {
      count++;
    }
    if (scl90Preg058 !== "0" && scl90Preg058 !== 0 && scl90Preg058 !== "") {
      count++;
    }
    if (scl90Preg059 !== "0" && scl90Preg059 !== 0 && scl90Preg059 !== "") {
      count++;
    }
    if (scl90Preg060 !== "0" && scl90Preg060 !== 0 && scl90Preg060 !== "") {
      count++;
    }
    if (scl90Preg061 !== "0" && scl90Preg061 !== 0 && scl90Preg061 !== "") {
      count++;
    }
    if (scl90Preg062 !== "0" && scl90Preg062 !== 0 && scl90Preg062 !== "") {
      count++;
    }
    if (scl90Preg063 !== "0" && scl90Preg063 !== 0 && scl90Preg063 !== "") {
      count++;
    }
    if (scl90Preg064 !== "0" && scl90Preg064 !== 0 && scl90Preg064 !== "") {
      count++;
    }
    if (scl90Preg065 !== "0" && scl90Preg065 !== 0 && scl90Preg065 !== "") {
      count++;
    }
    if (scl90Preg066 !== "0" && scl90Preg066 !== 0 && scl90Preg066 !== "") {
      count++;
    }
    if (scl90Preg067 !== "0" && scl90Preg067 !== 0 && scl90Preg067 !== "") {
      count++;
    }
    if (scl90Preg068 !== "0" && scl90Preg068 !== 0 && scl90Preg068 !== "") {
      count++;
    }
    if (scl90Preg069 !== "0" && scl90Preg069 !== 0 && scl90Preg069 !== "") {
      count++;
    }
    if (scl90Preg070 !== "0" && scl90Preg070 !== 0 && scl90Preg070 !== "") {
      count++;
    }
    if (scl90Preg071 !== "0" && scl90Preg071 !== 0 && scl90Preg071 !== "") {
      count++;
    }
    if (scl90Preg072 !== "0" && scl90Preg072 !== 0 && scl90Preg072 !== "") {
      count++;
    }
    if (scl90Preg073 !== "0" && scl90Preg073 !== 0 && scl90Preg073 !== "") {
      count++;
    }
    if (scl90Preg074 !== "0" && scl90Preg074 !== 0 && scl90Preg074 !== "") {
      count++;
    }
    if (scl90Preg075 !== "0" && scl90Preg075 !== 0 && scl90Preg075 !== "") {
      count++;
    }
    if (scl90Preg076 !== "0" && scl90Preg076 !== 0 && scl90Preg076 !== "") {
      count++;
    }
    if (scl90Preg077 !== "0" && scl90Preg077 !== 0 && scl90Preg077 !== "") {
      count++;
    }
    if (scl90Preg078 !== "0" && scl90Preg078 !== 0 && scl90Preg078 !== "") {
      count++;
    }
    if (scl90Preg079 !== "0" && scl90Preg079 !== 0 && scl90Preg079 !== "") {
      count++;
    }
    if (scl90Preg080 !== "0" && scl90Preg080 !== 0 && scl90Preg080 !== "") {
      count++;
    }
    if (scl90Preg081 !== "0" && scl90Preg081 !== 0 && scl90Preg081 !== "") {
      count++;
    }
    if (scl90Preg082 !== "0" && scl90Preg082 !== 0 && scl90Preg082 !== "") {
      count++;
    }
    if (scl90Preg083 !== "0" && scl90Preg083 !== 0 && scl90Preg083 !== "") {
      count++;
    }
    if (scl90Preg084 !== "0" && scl90Preg084 !== 0 && scl90Preg084 !== "") {
      count++;
    }
    if (scl90Preg085 !== "0" && scl90Preg085 !== 0 && scl90Preg085 !== "") {
      count++;
    }
    if (scl90Preg086 !== "0" && scl90Preg086 !== 0 && scl90Preg086 !== "") {
      count++;
    }
    if (scl90Preg087 !== "0" && scl90Preg087 !== 0 && scl90Preg087 !== "") {
      count++;
    }
    if (scl90Preg088 !== "0" && scl90Preg088 !== 0 && scl90Preg088 !== "") {
      count++;
    }
    if (scl90Preg089 !== "0" && scl90Preg089 !== 0 && scl90Preg089 !== "") {
      count++;
    }
    if (scl90Preg090 !== "0" && scl90Preg090 !== 0 && scl90Preg090 !== "") {
      count++;
    }

    return count;
  };

  // Calculo baremo percentil PST

  const percPstHomb =
    countNonZeroOrEmptyRespPst() < 5
      ? 0
      : countNonZeroOrEmptyRespPst() >= 5 && countNonZeroOrEmptyRespPst() < 8
      ? 5
      : countNonZeroOrEmptyRespPst() >= 8 && countNonZeroOrEmptyRespPst() < 10
      ? 10
      : countNonZeroOrEmptyRespPst() >= 10 &&
        countNonZeroOrEmptyRespPst() < 11.6
      ? 15
      : countNonZeroOrEmptyRespPst() >= 11.6 &&
        countNonZeroOrEmptyRespPst() < 13
      ? 20
      : countNonZeroOrEmptyRespPst() >= 13 && countNonZeroOrEmptyRespPst() < 14
      ? 25
      : countNonZeroOrEmptyRespPst() >= 14 && countNonZeroOrEmptyRespPst() < 16
      ? 30
      : countNonZeroOrEmptyRespPst() >= 16 && countNonZeroOrEmptyRespPst() < 18
      ? 35
      : countNonZeroOrEmptyRespPst() >= 18 && countNonZeroOrEmptyRespPst() < 19
      ? 40
      : countNonZeroOrEmptyRespPst() >= 19 && countNonZeroOrEmptyRespPst() < 20
      ? 45
      : countNonZeroOrEmptyRespPst() >= 20 &&
        countNonZeroOrEmptyRespPst() < 22.2
      ? 50
      : countNonZeroOrEmptyRespPst() >= 22.2 &&
        countNonZeroOrEmptyRespPst() < 24
      ? 55
      : countNonZeroOrEmptyRespPst() >= 24 && countNonZeroOrEmptyRespPst() < 26
      ? 60
      : countNonZeroOrEmptyRespPst() >= 26 && countNonZeroOrEmptyRespPst() < 28
      ? 65
      : countNonZeroOrEmptyRespPst() >= 28 && countNonZeroOrEmptyRespPst() < 31
      ? 70
      : countNonZeroOrEmptyRespPst() >= 31 && countNonZeroOrEmptyRespPst() < 33
      ? 75
      : countNonZeroOrEmptyRespPst() >= 33 && countNonZeroOrEmptyRespPst() < 39
      ? 80
      : countNonZeroOrEmptyRespPst() >= 39 &&
        countNonZeroOrEmptyRespPst() < 42.7
      ? 85
      : countNonZeroOrEmptyRespPst() >= 42.7 &&
        countNonZeroOrEmptyRespPst() < 48
      ? 90
      : countNonZeroOrEmptyRespPst() >= 48 &&
        countNonZeroOrEmptyRespPst() < 54.4
      ? 95
      : countNonZeroOrEmptyRespPst() >= 54.4 &&
        countNonZeroOrEmptyRespPst() < 61.9
      ? 97
      : countNonZeroOrEmptyRespPst() >= 61.9
      ? 99
      : "";

  const percPstMuj =
    countNonZeroOrEmptyRespPst() < 5
      ? 0
      : countNonZeroOrEmptyRespPst() >= 5 && countNonZeroOrEmptyRespPst() < 8
      ? 5
      : countNonZeroOrEmptyRespPst() >= 8 && countNonZeroOrEmptyRespPst() < 12
      ? 10
      : countNonZeroOrEmptyRespPst() >= 12 && countNonZeroOrEmptyRespPst() < 14
      ? 15
      : countNonZeroOrEmptyRespPst() >= 14 && countNonZeroOrEmptyRespPst() < 16
      ? 20
      : countNonZeroOrEmptyRespPst() >= 16 && countNonZeroOrEmptyRespPst() < 18
      ? 25
      : countNonZeroOrEmptyRespPst() >= 18 && countNonZeroOrEmptyRespPst() < 20
      ? 30
      : countNonZeroOrEmptyRespPst() >= 20 &&
        countNonZeroOrEmptyRespPst() < 22.6
      ? 35
      : countNonZeroOrEmptyRespPst() >= 22.6 &&
        countNonZeroOrEmptyRespPst() < 25.5
      ? 40
      : countNonZeroOrEmptyRespPst() >= 25.5 &&
        countNonZeroOrEmptyRespPst() < 27
      ? 45
      : countNonZeroOrEmptyRespPst() >= 27 && countNonZeroOrEmptyRespPst() < 29
      ? 50
      : countNonZeroOrEmptyRespPst() >= 29 && countNonZeroOrEmptyRespPst() < 31
      ? 55
      : countNonZeroOrEmptyRespPst() >= 31 && countNonZeroOrEmptyRespPst() < 33
      ? 60
      : countNonZeroOrEmptyRespPst() >= 33 && countNonZeroOrEmptyRespPst() < 34
      ? 65
      : countNonZeroOrEmptyRespPst() >= 34 && countNonZeroOrEmptyRespPst() < 36
      ? 70
      : countNonZeroOrEmptyRespPst() >= 36 && countNonZeroOrEmptyRespPst() < 39
      ? 75
      : countNonZeroOrEmptyRespPst() >= 39 && countNonZeroOrEmptyRespPst() < 43
      ? 80
      : countNonZeroOrEmptyRespPst() >= 43 &&
        countNonZeroOrEmptyRespPst() < 47.1
      ? 85
      : countNonZeroOrEmptyRespPst() >= 47.1 &&
        countNonZeroOrEmptyRespPst() < 55
      ? 90
      : countNonZeroOrEmptyRespPst() >= 55 &&
        countNonZeroOrEmptyRespPst() < 59.8
      ? 95
      : countNonZeroOrEmptyRespPst() >= 59.8 &&
        countNonZeroOrEmptyRespPst() < 68.6
      ? 97
      : countNonZeroOrEmptyRespPst() >= 68.6
      ? 99
      : "";

  // Calculo de PSDI

  const resultPsdi = (
    parseInt(totalSumScl) / parseInt(countNonZeroOrEmptyRespPst())
  ).toFixed(2);

  // Calculo baremo percentil PSDI

  const percPsdiHomb =
    resultPsdi < 1.03
      ? 0
      : resultPsdi >= 1.03 && resultPsdi < 1.13
      ? 5
      : resultPsdi >= 1.13 && resultPsdi < 1.18
      ? 10
      : resultPsdi >= 1.18 && resultPsdi < 1.23
      ? 15
      : resultPsdi >= 1.23 && resultPsdi < 1.3
      ? 20
      : resultPsdi >= 1.3 && resultPsdi < 1.35
      ? 25
      : resultPsdi >= 1.35 && resultPsdi < 1.44
      ? 30
      : resultPsdi >= 1.44 && resultPsdi < 1.48
      ? 35
      : resultPsdi >= 1.48 && resultPsdi < 1.52
      ? 40
      : resultPsdi >= 1.52 && resultPsdi < 1.56
      ? 45
      : resultPsdi >= 1.56 && resultPsdi < 1.65
      ? 50
      : resultPsdi >= 1.65 && resultPsdi < 1.73
      ? 55
      : resultPsdi >= 1.73 && resultPsdi < 1.85
      ? 60
      : resultPsdi >= 1.85 && resultPsdi < 2.0
      ? 65
      : resultPsdi >= 2.0 && resultPsdi < 2.03
      ? 70
      : resultPsdi >= 2.03 && resultPsdi < 2.15
      ? 75
      : resultPsdi >= 2.15 && resultPsdi < 2.22
      ? 80
      : resultPsdi >= 2.22 && resultPsdi < 2.28
      ? 85
      : resultPsdi >= 2.28 && resultPsdi < 2.49
      ? 90
      : resultPsdi >= 2.49 && resultPsdi < 2.65
      ? 95
      : resultPsdi >= 2.65 && resultPsdi < 2.96
      ? 97
      : resultPsdi >= 2.96
      ? 99
      : "";

  const percPsdiMuj =
    resultPsdi < 1.1
      ? 0
      : resultPsdi >= 1.1 && resultPsdi < 1.28
      ? 5
      : resultPsdi >= 1.18 && resultPsdi < 1.27
      ? 10
      : resultPsdi >= 1.27 && resultPsdi < 1.35
      ? 15
      : resultPsdi >= 1.35 && resultPsdi < 1.42
      ? 20
      : resultPsdi >= 1.42 && resultPsdi < 1.48
      ? 25
      : resultPsdi >= 1.48 && resultPsdi < 1.54
      ? 30
      : resultPsdi >= 1.54 && resultPsdi < 1.61
      ? 35
      : resultPsdi >= 1.61 && resultPsdi < 1.68
      ? 40
      : resultPsdi >= 1.68 && resultPsdi < 1.78
      ? 45
      : resultPsdi >= 1.78 && resultPsdi < 1.83
      ? 50
      : resultPsdi >= 1.83 && resultPsdi < 1.89
      ? 55
      : resultPsdi >= 1.89 && resultPsdi < 1.93
      ? 60
      : resultPsdi >= 1.93 && resultPsdi < 2.0
      ? 65
      : resultPsdi >= 2.0 && resultPsdi < 2.11
      ? 70
      : resultPsdi >= 2.11 && resultPsdi < 2.23
      ? 75
      : resultPsdi >= 2.23 && resultPsdi < 2.33
      ? 80
      : resultPsdi >= 2.33 && resultPsdi < 2.5
      ? 85
      : resultPsdi >= 2.5 && resultPsdi < 2.69
      ? 90
      : resultPsdi >= 2.69 && resultPsdi < 2.8
      ? 95
      : resultPsdi >= 2.8 && resultPsdi < 3.03
      ? 97
      : resultPsdi >= 3.03
      ? 99
      : "";

  return {
    totalSumSom,
    countSelectedResponsesSom,
    totalDimenSom,
    percSomHomb,
    percSomMuj,
    totalSumObs,
    countSelectedResponsesObs,
    totalDimenObs,
    percObsHomb,
    percObsMuj,
    totalSumSi,
    countSelectedResponsesSi,
    totalDimenSi,
    percSiHomb,
    percSiMuj,
    totalSumDep,
    countSelectedResponsesDep,
    totalDimenDep,
    percDepHomb,
    percDepMuj,
    totalSumAns,
    countSelectedResponsesAns,
    totalDimenAns,
    percAnsHomb,
    percAnsMuj,
    totalSumHos,
    countSelectedResponsesHos,
    totalDimenHos,
    percHosHomb,
    percHosMuj,
    totalSumFob,
    countSelectedResponsesFob,
    totalDimenFob,
    percFobHomb,
    percFobMuj,
    totalSumPar,
    countSelectedResponsesPar,
    totalDimenPar,
    percParHomb,
    percParMuj,
    totalSumPsic,
    countSelectedResponsesPsic,
    totalDimenPsic,
    percPsicHomb,
    percPsicMuj,
    totalSumAdi,
    countSelectedResponsesAdi,
    totalDimenAdi,
    totalSumScl,
    countSelectedResponsesScl,
    resultGsi,
    percGsiHomb,
    percGsiMuj,
    countNonZeroOrEmptyRespPst,
    percPstHomb,
    percPstMuj,
    resultPsdi,
    percPsdiHomb,
    percPsdiMuj,
  };
};
